export default __webpack_public_path__ + "static/media/06.cc0a4e49.jpg";